import React, { useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { Helmet } from "react-helmet";
import {
  FiCheck,
  FiChevronLeft,
  FiChevronRight,
  FiPhone,
  FiCalendar,
  FiMic,
  FiVolume2,
  FiUsers,
  FiAward,
} from "react-icons/fi";

const DiksiyonEtkili = () => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const topRef = useRef(null);

  const images = [
    "/img/services-detail/diksiyon1.jpg",
    "/img/services-detail/diksiyon2.jpg",
  ];

  const services = [
    {
      icon: FiMic,
      title: "Doğru ve Anlaşılır Konuşma",
      description:
        "Sesin doğru kullanımı, kelimelerin net telaffuzu, boğuk veya karışık seslerin düzeltilmesi.",
    },
    {
      icon: FiVolume2,
      title: "Nefes ve Ses Kontrolü",
      description:
        "Konuşma sırasında nefes teknikleri ile sesin uzun süre ve doğru tonlamayla kullanılmasını sağlama.",
    },
    {
      icon: FiUsers,
      title: "Topluluk Önünde Konuşma",
      description:
        "Sunum, toplantı veya ders anlatımında kendine güvenle konuşma ve mesajı etkili iletme.",
    },
    {
      icon: FiAward,
      title: "Beden Dili ve İletişim",
      description:
        "Jest, mimik ve duruş gibi sözsüz iletişim öğeleri ile mesajın güçlendirilmesi.",
    },
  ];

  const additionalServices = [
    "Vurgu ve tonlama çalışmaları, monotonluktan kaçınma",
    "Çocuklara yönelik konuşma eğitimi ve kendini ifade etme",
    "Yetişkinlere yönelik iş hayatında etkili iletişim desteği",
    "Ses ve konuşma terapisi desteği, gerektiğinde yönlendirme",
  ];

  const targetGroups = [
    { title: "Çocuklar", desc: "Yaşına uygun yöntemlerle" },
    { title: "Öğrenciler", desc: "Sunum ve sınav hazırlığı" },
    { title: "Yetişkinler", desc: "İş hayatı ve sosyal yaşam" },
  ];

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  // Auto slide
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % images.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [images.length]);

  const nextSlide = () => setCurrentSlide((prev) => (prev + 1) % images.length);
  const prevSlide = () =>
    setCurrentSlide((prev) => (prev - 1 + images.length) % images.length);

  return (
    <section
      ref={topRef}
      style={{
        paddingTop: "140px",
        paddingBottom: "80px",
        backgroundColor: "#f8fafc",
        minHeight: "100vh",
      }}
    >
      <Helmet>
        <title>
          Diksiyon ve Etkili Konuşma | Dilan Aslan | Çocuk Gelişim Danışmanlığı
        </title>
        <meta
          name="description"
          content="Diksiyon ve etkili konuşma eğitimi. Doğru telaffuz, nefes kontrolü, topluluk önünde konuşma ve beden dili eğitimi."
        />
      </Helmet>

      <div style={{ maxWidth: "1200px", margin: "0 auto", padding: "0 24px" }}>
        {/* Hero Section */}
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          style={{
            background: "linear-gradient(135deg, #ea580c 0%, #c2410c 100%)",
            borderRadius: "24px",
            padding: "48px",
            marginBottom: "48px",
            position: "relative",
            overflow: "hidden",
          }}
        >
          {/* Decorative circles */}
          <div
            style={{
              position: "absolute",
              top: "-50px",
              right: "-50px",
              width: "200px",
              height: "200px",
              background:
                "radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)",
              borderRadius: "50%",
            }}
          />
          <div
            style={{
              position: "absolute",
              bottom: "-30px",
              left: "30%",
              width: "120px",
              height: "120px",
              background:
                "radial-gradient(circle, rgba(255,255,255,0.08) 0%, transparent 70%)",
              borderRadius: "50%",
            }}
          />

          <div style={{ position: "relative", zIndex: 1 }}>
            <div
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "rgba(255,255,255,0.2)",
                color: "#fed7aa",
                padding: "8px 16px",
                borderRadius: "50px",
                fontSize: "0.85rem",
                fontWeight: "600",
                marginBottom: "16px",
              }}
            >
              <FiMic size={18} />
              ETKİLİ İLETİŞİM
            </div>
            <h1
              style={{
                fontSize: "2.5rem",
                fontWeight: "800",
                color: "white",
                marginBottom: "16px",
                lineHeight: "1.2",
              }}
            >
              Diksiyon ve Etkili Konuşma
            </h1>
            <p
              style={{
                fontSize: "1.1rem",
                color: "#fed7aa",
                maxWidth: "600px",
                lineHeight: "1.7",
                marginBottom: "24px",
              }}
            >
              Doğru ve etkili iletişim becerilerinizi geliştirerek özgüvenli bir
              şekilde kendinizi ifade edin.
            </p>
            <a
              href="#contact"
              style={{
                display: "inline-flex",
                alignItems: "center",
                gap: "8px",
                backgroundColor: "white",
                color: "#ea580c",
                padding: "14px 28px",
                borderRadius: "12px",
                fontWeight: "600",
                textDecoration: "none",
                fontSize: "0.95rem",
              }}
            >
              <FiCalendar size={18} />
              Randevu Al
            </a>
          </div>
        </motion.div>

        {/* Hedef Kitle */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.1 }}
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "16px",
            marginBottom: "32px",
          }}
        >
          {targetGroups.map((group, index) => (
            <div
              key={index}
              style={{
                backgroundColor: "white",
                borderRadius: "16px",
                padding: "20px",
                textAlign: "center",
                boxShadow: "0 4px 15px rgba(0,0,0,0.04)",
                border: "1px solid #f1f5f9",
              }}
            >
              <h4
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "#ea580c",
                  marginBottom: "4px",
                }}
              >
                {group.title}
              </h4>
              <p style={{ fontSize: "0.85rem", color: "#64748b", margin: 0 }}>
                {group.desc}
              </p>
            </div>
          ))}
        </motion.div>

        {/* Content Grid */}
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 400px",
            gap: "32px",
            marginBottom: "48px",
          }}
        >
          {/* Sol - Hizmetler */}
          <motion.div
            initial={{ opacity: 0, x: -30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <h2
              style={{
                fontSize: "1.75rem",
                fontWeight: "700",
                color: "#0f172a",
                marginBottom: "24px",
              }}
            >
              Verilen Hizmetler
            </h2>

            {/* Ana Hizmet Kartları */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1fr",
                gap: "16px",
                marginBottom: "32px",
              }}
            >
              {services.map((service, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.4, delay: 0.3 + index * 0.1 }}
                  style={{
                    backgroundColor: "white",
                    borderRadius: "16px",
                    padding: "24px",
                    boxShadow: "0 4px 15px rgba(0,0,0,0.04)",
                    border: "1px solid #f1f5f9",
                  }}
                >
                  <div
                    style={{
                      width: "48px",
                      height: "48px",
                      borderRadius: "12px",
                      backgroundColor: "#ffedd5",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      marginBottom: "16px",
                    }}
                  >
                    <service.icon size={24} color="#ea580c" />
                  </div>
                  <h3
                    style={{
                      fontSize: "1.1rem",
                      fontWeight: "600",
                      color: "#0f172a",
                      marginBottom: "8px",
                    }}
                  >
                    {service.title}
                  </h3>
                  <p
                    style={{
                      fontSize: "0.9rem",
                      color: "#64748b",
                      lineHeight: "1.6",
                      margin: 0,
                    }}
                  >
                    {service.description}
                  </p>
                </motion.div>
              ))}
            </div>

            {/* Ek Hizmetler Listesi */}
            <div
              style={{
                backgroundColor: "white",
                borderRadius: "16px",
                padding: "24px",
                boxShadow: "0 4px 15px rgba(0,0,0,0.04)",
                border: "1px solid #f1f5f9",
              }}
            >
              <h3
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "#0f172a",
                  marginBottom: "16px",
                }}
              >
                Diğer Hizmetlerimiz
              </h3>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {additionalServices.map((item, index) => (
                  <div
                    key={index}
                    style={{
                      display: "flex",
                      alignItems: "flex-start",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        backgroundColor: "#ffedd5",
                        borderRadius: "6px",
                        width: "24px",
                        height: "24px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        flexShrink: 0,
                        marginTop: "2px",
                      }}
                    >
                      <FiCheck size={14} color="#ea580c" />
                    </div>
                    <span
                      style={{
                        color: "#475569",
                        fontSize: "0.95rem",
                        lineHeight: "1.5",
                      }}
                    >
                      {item}
                    </span>
                  </div>
                ))}
              </div>
            </div>
          </motion.div>

          {/* Sağ - Slider */}
          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
            style={{ position: "sticky", top: "160px", height: "fit-content" }}
          >
            {/* Image Slider */}
            <div
              style={{
                position: "relative",
                borderRadius: "20px",
                overflow: "hidden",
                boxShadow: "0 10px 40px rgba(0,0,0,0.1)",
                marginBottom: "16px",
              }}
            >
              <img
                src={images[currentSlide]}
                alt={`Diksiyon Eğitimi ${currentSlide + 1}`}
                style={{
                  width: "100%",
                  height: "300px",
                  objectFit: "cover",
                  display: "block",
                }}
              />

              {/* Navigation Arrows */}
              <button
                onClick={prevSlide}
                style={{
                  position: "absolute",
                  left: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                }}
              >
                <FiChevronLeft size={20} color="#0f172a" />
              </button>
              <button
                onClick={nextSlide}
                style={{
                  position: "absolute",
                  right: "12px",
                  top: "50%",
                  transform: "translateY(-50%)",
                  backgroundColor: "rgba(255,255,255,0.9)",
                  border: "none",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
                }}
              >
                <FiChevronRight size={20} color="#0f172a" />
              </button>

              {/* Dots */}
              <div
                style={{
                  position: "absolute",
                  bottom: "16px",
                  left: "50%",
                  transform: "translateX(-50%)",
                  display: "flex",
                  gap: "8px",
                }}
              >
                {images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => setCurrentSlide(index)}
                    style={{
                      width: currentSlide === index ? "24px" : "8px",
                      height: "8px",
                      borderRadius: "4px",
                      backgroundColor:
                        currentSlide === index
                          ? "#ea580c"
                          : "rgba(255,255,255,0.6)",
                      border: "none",
                      cursor: "pointer",
                      transition: "all 0.3s ease",
                    }}
                  />
                ))}
              </div>
            </div>

            {/* CTA Card */}
            <div
              style={{
                backgroundColor: "#fff7ed",
                borderRadius: "16px",
                padding: "24px",
                border: "1px solid #fed7aa",
              }}
            >
              <h4
                style={{
                  fontSize: "1.1rem",
                  fontWeight: "600",
                  color: "#c2410c",
                  marginBottom: "12px",
                }}
              >
                🎤 Deneme Dersi
              </h4>
              <p
                style={{
                  fontSize: "0.9rem",
                  color: "#ea580c",
                  marginBottom: "16px",
                  lineHeight: "1.5",
                }}
              >
                İlk ders için bizi arayın, ihtiyaçlarınızı birlikte
                değerlendirelim.
              </p>
              <a
                href="tel:+905055517747"
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  backgroundColor: "#ea580c",
                  color: "white",
                  padding: "12px 20px",
                  borderRadius: "10px",
                  fontWeight: "600",
                  textDecoration: "none",
                  fontSize: "0.95rem",
                }}
              >
                <FiPhone size={18} />
                +90 505 551 77 47
              </a>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Responsive Style */}
      <style>
        {`
          @media (max-width: 900px) {
            section > div > div:nth-child(3) {
              grid-template-columns: 1fr !important;
            }
            section > div > div:nth-child(3) > div:last-child {
              position: relative !important;
              top: 0 !important;
            }
            section > div > div:nth-child(2) {
              grid-template-columns: 1fr !important;
            }
          }
          @media (max-width: 600px) {
            section > div > div:nth-child(3) > div:first-child > div:first-child {
              grid-template-columns: 1fr !important;
            }
          }
        `}
      </style>
    </section>
  );
};

export default DiksiyonEtkili;
